import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const MenuItem = ({ item, activeItem, setActiveItem, isOpen }) => {
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;

    const toggleSubMenu = (e) => {
        e.stopPropagation();
        if (item.submenu) {
            setActiveItem(item.name === activeItem ? '' : item.name);
        }
    };

    const handleMouseEnter = () => {
        if (!isOpen && item.submenu) {
            setIsSubmenuOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (!isOpen && item.submenu) {
            setIsSubmenuOpen(false);
        }
    };

    const isActive =
    item.path === currentPath ||
    (item.submenu && item.submenu.some((sub) => sub.path === currentPath));

    return (
        <li
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <NavLink
                to={item.path}
                className={({ isActive: routeIsActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-xl transition-all duration-300 ease-in-out dark:text-white hover:text-primary-color ${isActive || routeIsActive
                        ? 'bg-white border-l-[3px] border-[#00B4D2] shadow-[0px_3px_8.6px_0px_#00B4D233] text-primary-color'
                        : 'text-[#1b2f51] hover:bg-white/60 hover:shadow-sm dark:hover:bg-white dark:hover:text-primary-color'
                    }`
                }
                onClick={toggleSubMenu}
            >
                <span className="flex items-center justify-center w-[28px] h-[28px] rounded bg-transparent dark:bg-[#dfe0e6]">{item.icon}</span>
                {isOpen && <span className="flex-1 truncate dark:text-primary-color">{item.name}</span>}
                {item.submenu && isOpen && (
                    <span className="ml-auto">
                        {isActive ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                )}
            </NavLink>

            {/* Expanded submenu in full width */}
            {item.submenu && isOpen && (
            (isActive || item.submenu.some(sub => sub.path === currentPath)) && (
                <ul className="ml-6 mt-[10px] px-2 border-l border-dashed border-gray-secondary dark:border-white transition-all duration-300 ease-in-out">
                    {item.submenu.map((subitem) => (
                        <li key={subitem.id}>
                            <NavLink
                                to={subitem.path}
                                className={({ isActive }) =>
                                    `flex items-center gap-2 px-3 py-1 text-sm rounded-md transition-all mt-1 dark:text-white ${isActive
                                        ? 'text-primary-color dark:text-gray-400'
                                        : 'text-[#1b2f51] hover:bg-gray-100 hover:text-primary-color dark:hover:text-primary-color'
                                    }`
                                }
                            >
                                {/* <span className="w-4 h-4">{subitem.icon}</span> */}
                                <span className='w-28'>{subitem.name}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            )
            )}


            {/* Popup submenu when collapsed */}
            {item.submenu && !isOpen && isSubmenuOpen && (
                <ul className="absolute left-9 top-0 ml-2 p-2 w-48 border border-gray-200 shadow-md rounded-lg bg-white z-50">
                    {item.submenu.map((subitem) => (
                        <li key={subitem.id}>
                            <NavLink
                                to={subitem.path}
                                className={({ isActive }) =>
                                    `flex items-center gap-2 px-3 py-1 text-sm rounded-md transition-all ${isActive
                                        ? 'bg-white border-l-[3px] border-[#00B4D2] text-primary-color'
                                        : 'hover:bg-gray-100 hover:text-primary-color text-[#1b2f51]'
                                    }`
                                }
                            >
                                <span className="w-4 h-4">{subitem.icon}</span>
                                <span className='w-28'>{subitem.name}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default MenuItem;
